<template>
  <div class="ess-main-meters">
    <div v-for="mainGatewayMeter in mainGatewayMeters" class="ess-main-meters__wrap">
      <EssGatewayMeter class="ess-main-meter" :gatewayMeter="mainGatewayMeter.mainMeter" />
      <div class="ess-cabe" style="width: 95%; margin-top: 0;">
        <div class="ess-cabe__text">10kv母线</div>
      </div>
      <div class="ess-unit-wrap" :class="{ 'one': mainGatewayMeter.units.length === 1 }" ref="unitWrap">
        <div class="ess-unit" :class="{ 'one': mainGatewayMeter.units.length === 1 }"
          v-for="unit in mainGatewayMeter.units" :key="unit.unitId">
          <div class="ess-transformer">
            <div class="ess-line down"></div>
            <div class="ess-transformer-box">
              <img src="@/assets/images/topo/ic_transformer.png" height="24" alt="" srcset="">
              <span class="ess-node-text">{{ unit.unitName }}</span>
            </div>
            <div class="ess-line down"></div>
            <div class="ess-cabe ess-cabe--380" style="width: 95%">
              <div class="ess-cabe__text">380v母线</div>
            </div>
            <div class="ess-meter-list">
              <EssGatewayMeter :gatewayMeter="gatewayMeter" v-for="gatewayMeter in unit.gatewayMeters" />
            </div>
          </div>

          <div class="ess-cabe ess-cabe--380">
            <div class="ess-cabe__text">380v母线</div>
          </div>

          <div class="ess-meter-parallel">
            <EssPayload :eLinks="unit.eLinks" />
            <div class="ess-meter-parallel-box" v-for="eLink in unit.eLinks" :key="eLink.id">
              <EssCombinedMeter :combinedMeter="eLink.combinedMeter" />
              <EssELink :data="eLink" />

              <div class="ess-eblock-wrap" :class="{ 'shrink': eLink.open }">
                <el-badge :value="eLink.eBlocks.length" type="primary" class="ess-shrink-badge"
                  :hidden="!eLink.open || !eLink.eBlocks.length">
                  <div class="ess-shrink-box" @click="eLink.open = !eLink.open"></div>
                </el-badge>
                <div class="ess-cabe ess-cabe--380 ess-cabe--eblock">
                  <div class="ess-cabe__text">380v母线</div>
                </div>
                <div class="ess-eblock-list">
                  <EssEBlock :data="eBlock" v-for="eBlock in eLink.eBlocks" :key="eBlock.id" />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref } from 'vue'

import EssEBlock from './EssEBlock.vue'
import EssELink from './EssELink.vue'
import EssPayload from './EssPayload.vue'
import EssGatewayMeter from './EssGatewayMeter.vue'
import EssCombinedMeter from './EssCombinedMeter.vue'

const props = defineProps(['mainGatewayMeters'])
console.log('props', props.mainGatewayMeters)

</script>

